<template>
  <div class="card card-custom">
    <div class="card-header">
      <h3 class="card-title" style="width: 100%">
        Filters
      </h3>
    </div>
    <form v-on:submit="loadReport">
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>Branch</label>
              <select class="form-control" v-model="filter.BRANCH_ID">
                <option v-for="item in branches" :key="item.BA_ID" :value="item.BA_ID">
                  {{ item.TITLE }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Client Type</label>
              <select class="form-control" v-model="filter.PTR_ID">
                <option v-for="item in partnerTypes" :key="item.PTR_ID" :value="item.ID">
                  {{ item.Title }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Director Cnic Status</label>
              <select class="form-control" v-model="filter.Director">
                <option value="0">All</option>
                <option value="1">Expired</option>
                <option value="2">UnExpired</option>
              </select>
            </div>
          </div>
          <!--<div class="col-md-4">
            <div class="form-group">
              <label>Benificiary Cnic Status</label>
              <select class="form-control" v-model="filter.Benificiary">
                <option value="0">All</option>
                <option value="1">Expired</option>
                <option value="2">UnExpired</option>
              </select>
            </div>
          </div>-->
          <div class="col-md-4">
            <div class="form-group">
              <label>Individual Cnic Status</label>
              <select class="form-control" v-model="filter.Individual">
                <option value="0">All</option>
                <option value="1">Expired</option>
                <option value="2">UnExpired</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>CNIC Verification Status(By Nadra)</label>
              <select class="form-control" v-model="filter.Verification">
                <option value="0">All</option>
                <option value="1">Verified</option>
                <option value="2">UnVerified</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="card-footer">
        <div class="float-right">
          <input type="button" value="Clear" class="btn btn-danger btn-sm  " v-on:click="clear()" />
          <button class="btn btn-success btn-sm" type="submit">Print Report</button>
        </div>
      </div>
    </form>
  </div>

</template>

<script>
const axios = require('axios').default;
    export default ({
        data() {
            return {
              filter: { BRANCH_ID: 0, PTR_ID: 0, Director: 0, /*Benificiary: 0,*/ Individual: 0, Verification: 0},
              branches: [],
              partnerTypes: [],
            }
        },

        created: function () {
          this.pageLoad();
          this.setFiltersFromURL();
        },

        methods: {
            pageLoad() {
                startReq();
                var vm = this;
                axios.post('/api/UICApi/pageLoadClientReport')
                    .then(function (res) {
                      endReq();
                      vm.partnerTypes = res.data.partnerTypes;
                      vm.branches = res.data.list.map(item => ({
                        BA_ID: item.BA_ID,
                        BA_BRANCH: item.BA_BRANCH,
                        BP_ID: item.BP_ID,
                        BA_ISACTIVE: item.BA_ISACTIVE || 'Y',
                        TITLE: item.TITLE
                      }));
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
          },
          setFiltersFromURL() {
            const params = new URLSearchParams(window.location.search);

            if (params.get('Director')) {
              this.filter.Director = parseInt(params.get('Director'));
            }

            if (params.get('Individual')) {
              this.filter.Individual = parseInt(params.get('Individual'));
            }

            if (params.get('Verification')) {
              this.filter.Verification = parseInt(params.get('Verification'));
            }
          },
          loadReport(e) {
            e.preventDefault();
            var vm = this;
            const url = "../UIC/ClientReportPrint?BRANCH_ID=" + vm.filter.BRANCH_ID +
              "&PTR_ID=" + vm.filter.PTR_ID +
              "&Director=" + vm.filter.Director +
              //"&Benificiary=" + vm.filter.Benificiary +
              "&Individual=" + vm.filter.Individual +
              "&Verification=" + vm.filter.Verification;
            window.open(url, "_blank");
          },
          clear() {
            this.filter = { BRANCH_ID: 0, PTR_ID: 0, Director: 0, /*Benificiary: 0,*/ Individual: 0, Verification: 0 };
          },
        }
  });
</script>



// WEBPACK FOOTER //
// src/components/ims/ClientReport.vue